import { GuardUtils } from './../GuardUtils';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ToastService } from 'src/app/services/toast/toast.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class UnauthGuard implements CanActivate {
  constructor(
    private guardUtils: GuardUtils,
    private router: Router,
    private storage: StorageService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // Verificar se estamos em processo de logout na página de reset de senha
    // Se sim, sempre permitir acesso para evitar redirecionamentos
    const isLogoutInProgress = sessionStorage.getItem('@reset-password:logout-in-progress') === 'true';
    if (isLogoutInProgress && state.url.includes('/reset-password')) {
      return true;
    }

    const authenticated = this.guardUtils.isAuthenticated();

    if (!authenticated) {
      return true;
    }

    // Permite acesso à rota de reset-password mesmo quando autenticado
    // O componente irá tratar a lógica de mostrar o modal
    if (state.url.includes('/reset-password')) {
      return true;
    }

    // Se já está autenticado, redireciona para dashboard
    // Não usa last_route para evitar redirecionamentos incorretos
    const redirectTo = route.data?.redirectTo || '/app/dashboard';
    
    // Valida se redirectTo é uma URL válida antes de fazer parse
    if (redirectTo && redirectTo !== 'undefined' && redirectTo.startsWith('/')) {
      return this.router.parseUrl(redirectTo);
    }
    
    // Fallback seguro
    return this.router.parseUrl('/app/dashboard');
  }
}
